import { render, staticRenderFns } from "./xinyangBigData_动态页面_不下钻.vue?vue&type=template&id=06920702&scoped=true"
import script from "./xinyangBigData_动态页面_不下钻.vue?vue&type=script&lang=js"
export * from "./xinyangBigData_动态页面_不下钻.vue?vue&type=script&lang=js"
import style0 from "./xinyangBigData_动态页面_不下钻.vue?vue&type=style&index=0&id=06920702&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06920702",
  null
  
)

export default component.exports